import {inject, Injectable} from '@angular/core';
import {Menu} from "../types/left-menu.types";
import {AuthService} from "../../../services/auth.service";
import {UtilityService} from "../../../services/utility.service";

@Injectable({
  providedIn: 'root'
})
export class LeftMenuService {
  private authService: AuthService = inject(AuthService);
  private utilityService: UtilityService = inject(UtilityService);

  public isMenuAvailableToCurrentUser(menu: Menu): boolean {
    if (!!menu.excludedRoles?.length) {
      const excludedRoles = menu.excludedRoles;
      const currentUserRoles = this.authService.getUserRoles();

      return !this.utilityService.isArrayContainsAnyElementOfAnotherArray(excludedRoles, currentUserRoles);
    }

    if (!menu.availableRoles?.length) { return true; }

    const availableRoles = menu.availableRoles;
    const currentUserRoles = this.authService.getUserRoles();

    return this.utilityService.isArrayContainsAnyElementOfAnotherArray(availableRoles, currentUserRoles);
  }
}
